const MSIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M0.78125 0.782227H8.60734V8.60831H0.78125V0.782227Z"
        fill="#F35325"
      />
      <path
        d="M9.39062 0.782227H17.2167V8.60831H9.39062V0.782227Z"
        fill="#81BC06"
      />
      <path
        d="M0.78125 9.3916H8.60734V17.2177H0.78125V9.3916Z"
        fill="#05A6F0"
      />
      <path
        d="M9.39062 9.3916H17.2167V17.2177H9.39062V9.3916Z"
        fill="#FFBA08"
      />
    </svg>
  );
};

export default MSIcon;
